interface IProps {
  score1: number;
  score2: number;
}

const TnCGGameScores: React.FC<IProps> = ({ score1, score2 }: IProps) => (
  <>
    <div className="tncGameScoreWrapper">
      <span className="tncGameScoreText">HOME</span>
      <span className="tncGameScoreValue">{score1}</span>
    </div>
    <div className="tncGameScoreWrapper">
      <span className="tncGameScoreText">&nbsp;</span>
      <span className="tncGameScoreValue">-</span>
    </div>
    <div className="tncGameScoreWrapper">
      <span className="tncGameScoreText">AWAY</span>
      <span className="tncGameScoreValue">{score2}</span>
    </div>
  </>
);

export default TnCGGameScores;
